/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_ToysInputs */

const he_home_category_toys = /** @type {(inputs: Home_Category_ToysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צעצועים ומשחקים`)
};

const en_home_category_toys = /** @type {(inputs: Home_Category_ToysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toys & Games`)
};

/**
* | output |
* | --- |
* | "Toys & Games" |
*
* @param {Home_Category_ToysInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_toys = /** @type {((inputs?: Home_Category_ToysInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_ToysInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_toys(inputs)
	return en_home_category_toys(inputs)
});